import React from "react";

const QuantityBreaks = ({ hover }: { hover?: boolean }) => {
  if (hover) {

    return (
      <svg width="148" height="74" viewBox="0 0 148 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_191_1552)">
          <rect x="8.5" y="6.5" width="131" height="57" rx="4.5" stroke="#8B95AA" />
          <rect x="16" y="14" width="31" height="3" rx="1.5" fill="#D8DEE9" />
          <rect x="118" y="14" width="14" height="3" rx="1.5" fill="#D8DEE9" />
          <rect x="16.5" y="22.5" width="115" height="9" rx="2.5" fill="#F4F7FC" stroke="#8B95AA" />
          <rect x="20.5" y="25.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="16.5" y="34.5" width="115" height="9" rx="2.5" fill="#F4F7FC" stroke="#8B95AA" />
          <rect x="20.5" y="37.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="25.5" y="37.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="120" y="38" width="7" height="2" rx="1" fill="#D8DEE9" />
          <rect x="16.5" y="46.5" width="115" height="9" rx="2.5" fill="#F4F7FC" stroke="#1879B9" />
          <rect x="20.5" y="49.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="25.5" y="49.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="30.5" y="49.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="118" y="50" width="9" height="2" rx="1" fill="#D8DEE9" />
          <g clip-path="url(#clip0_191_1552)">
            <rect x="128" y="45" width="6" height="6" rx="3" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M131 45C132.65 45 134 46.35 134 48C134 49.65 132.65 51 131 51C129.35 51 128 49.65 128 48C128 46.35 129.35 45 131 45ZM132.634 46.9318C132.562 46.8576 132.444 46.8559 132.369 46.9281L130.571 48.676L129.631 47.7614C129.556 47.6892 129.438 47.6909 129.366 47.7651C129.293 47.8394 129.295 47.9581 129.369 48.0303L130.441 49.0719C130.513 49.1427 130.629 49.1427 130.702 49.0719L132.631 47.1969C132.705 47.1248 132.707 47.006 132.634 46.9318Z" fill="#1879B9" />
          </g>
          <rect x="127.75" y="44.75" width="6.5" height="6.5" rx="3.25" stroke="white" stroke-width="0.5" />
        </g>
        <defs>
          <filter id="filter0_d_191_1552" x="0" y="0" width="148" height="74" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_191_1552" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_191_1552" result="shape" />
          </filter>
          <clipPath id="clip0_191_1552">
            <rect x="128" y="45" width="6" height="6" rx="3" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  return (
    <svg width="148" height="74" viewBox="0 0 148 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_191_1526)">
          <rect x="8.5" y="6.5" width="131" height="57" rx="4.5" stroke="#8B95AA" />
          <rect x="16" y="14" width="31" height="3" rx="1.5" fill="#D8DEE9" />
          <rect x="118" y="14" width="14" height="3" rx="1.5" fill="#D8DEE9" />
          <rect x="16.5" y="22.5" width="115" height="9" rx="2.5" fill="#F4F7FC" stroke="#8B95AA" />
          <rect x="20.5" y="25.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="16.5" y="34.5" width="115" height="9" rx="2.5" fill="#F4F7FC" stroke="#8B95AA" />
          <rect x="20.5" y="37.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="25.5" y="37.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="120" y="38" width="7" height="2" rx="1" fill="#D8DEE9" />
          <rect x="16.5" y="46.5" width="115" height="9" rx="2.5" fill="#F4F7FC" stroke="#8B95AA" />
          <rect x="20.5" y="49.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="25.5" y="49.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="30.5" y="49.5" width="3" height="3" rx="0.5" fill="#8B95AA" stroke="#8B95AA" />
          <rect x="118" y="50" width="9" height="2" rx="1" fill="#D8DEE9" />
          <g clip-path="url(#clip0_191_1526)">
            <rect x="128" y="45" width="6" height="6" rx="3" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M131 45C132.65 45 134 46.35 134 48C134 49.65 132.65 51 131 51C129.35 51 128 49.65 128 48C128 46.35 129.35 45 131 45ZM132.634 46.9318C132.562 46.8576 132.444 46.8559 132.369 46.9281L130.571 48.676L129.631 47.7614C129.556 47.6892 129.438 47.6909 129.366 47.7651C129.293 47.8394 129.295 47.9581 129.369 48.0303L130.441 49.0719C130.513 49.1427 130.629 49.1427 130.702 49.0719L132.631 47.1969C132.705 47.1248 132.707 47.006 132.634 46.9318Z" fill="#8B95AA" />
          </g>
          <rect x="127.75" y="44.75" width="6.5" height="6.5" rx="3.25" stroke="white" stroke-width="0.5" />
        </g>
        <defs>
          <filter id="filter0_d_191_1526" x="0" y="0" width="148" height="74" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_191_1526" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_191_1526" result="shape" />
          </filter>
          <clipPath id="clip0_191_1526">
            <rect x="128" y="45" width="6" height="6" rx="3" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};

export default QuantityBreaks;
